<script>

  /*
  |--------------------------------------------------------------------------
  | Dependency Definitions
  |--------------------------------------------------------------------------
  */

  import Vue from 'vue';
  import vueDebounce from 'vue-debounce'

  Vue.use(vueDebounce);

  import axios from 'axios';



  /*
  |--------------------------------------------------------------------------
  | Component Implementation
  |--------------------------------------------------------------------------
  */

  export default {
    name: 'internal-information',

    props: [
      'productID',
      'internalInformation',
      'language'
    ],

    mounted() {
      this.currentInternalInformation = this.internalInformation;
    },

    data() {
      return {
        currentInternalInformation: ''
      }
    },

    computed: {
    },

    methods: {
      fetchCustomers() {
        var self = this;

        axios.get('/api/v1/customers')
        .then(function (response) {
          self.customers = response.data.data;
        })
        .catch(function (error) {
          console.log("Error fetching customers: ", error);
        });
      },

      updateInternalInformation() {
        var self = this;

        axios.put('/api/v1/products/' + this.productID + '/internal', {
          language: this.language,
          internal_information: this.currentInternalInformation
        })
        .then(function (response) {
        })
        .catch(function (error) {
          console.log("Error updating internal information: ", error);
        });
      }
    }
  };
</script>

<template>
  <div>
    <textarea rows="3" class="w-100" v-model="currentInternalInformation" v-debounce:500ms.lock="updateInternalInformation"></textarea>
  </div>
</template>
